import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";

import { ConfirmDraftInvoicesPopupStyle } from "./style";

function ConfirmDraftInvoicesPopup(props) {
  const classes = ConfirmDraftInvoicesPopupStyle();
  const [scroll] = useState("body");
  return (
    <div className={classes.ConfirmWrapper}>
      <Dialog
        open={props.open}
        scroll={scroll}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.customModal}
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: "left" }}>Confirm invoice Re-generation</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{ maxWidth: "500px", textAlign: "left", marginLeft: 0 }}>
            This will permanently reject all draft invoices and create new ones
            with the updated charges.
            This action cannot be undone. Are you sure you want to proceed?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={props.handleConfirm}
            color="primary"
            className="primary-btn gray-border-btn"
          >
            Cancel
          </Button>
          <Button
            onClick={props.reGenerateDraftInvoices}
            color="primary"
            className="orange-btn primary-btn"
            style={{ maxWidth: "220px", textTransform: "none" }}
          >
            Confirm & Re-generate
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default ConfirmDraftInvoicesPopup;
